import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const GroupCard = styled.div`
  ${tw`flex flex-col gap-4 px-6 py-4 border rounded-25px border-gray94 h-full`}
`;
